module.exports = __webpack_public_path__ + "img/营销效果评估.4a2a4ac3.png";